import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  SpeechAI,
  SpeechCustomizedSolution,
  SpeechSecurityMeasures,
  SpeechProvenRecord,
  SpeechCompliance,
  SpeechIntegration,
} from "../../../app-constants";
import { Link } from "gatsby";

function Whychoosespeeech() {
  return (
    <section className="voice_services why_choose_speech p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Why Choose TekRevol as Your Speech Recognition Company</h2>
            <p>
              As a tech-driven company, TekRevol excels in{" "}
              <Link to="https://www.tekrevol.com/ai-development-company">
                artificial intelligence development
              </Link>{" "}
              by offering advanced speech recognition systems backed by our
              comprehensive experience and best practices that are second nature
              to our developers. Our commitment to innovation enables us to
              deliver high-quality speech recognition software services tailored
              to the dynamic needs of modern enterprises.
            </p>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">{SpeechAI}</div>
                    <div className="voice_service_head">
                      <h5>Expertise in AI & ML</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Integrating features of AI and ML into building and
                      creating very accurate and efficient speech recognition
                      models.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">
                      {SpeechCustomizedSolution}
                    </div>
                    <div className="voice_service_head">
                      <h5>Customized Solutions</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      The adaptation of the solutions due to the requirements of
                      certain businesses, achieving maximum performance and
                      compatibility.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">
                      {SpeechSecurityMeasures}
                    </div>
                    <div className="voice_service_head">
                      <h5>Security Measures</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Ensuring that client information and transactions are
                      secured through voice identification technology among
                      others.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">
                      {SpeechProvenRecord}
                    </div>
                    <div className="voice_service_head">
                      <h5>Proven Track Record</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Proven industry experience in implementing speech
                      recognition solutions that improve business performance.
                    </p>
                  </div>
                </div>
              </Col>

              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">{SpeechCompliance}</div>
                    <div className="voice_service_head">
                      <h5>Compliance & Standards</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Following the set industrial practices and laws to
                      increase the reliability of the recommended solutions.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">{SpeechIntegration}</div>
                    <div className="voice_service_head">
                      <h5>Integration Capabilities</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      We link voice recognition technologies to organizational
                      applications to improve overall organizational
                      productivity.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center mt-sm-3 mt-md-5"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book Your Consultation Today!
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychoosespeeech;
